/**
 * Shown for the moment a screen is still downloading. Most of the time it never
 * appears at all: the screen is fetched as soon as a game is picked.
 */
export function Loading() {
  return (
    <main className="screen" style={{ display: 'grid', placeItems: 'center' }}>
      <div className="logo neon neon-pink flicker" style={{ fontSize: 28 }} role="status">
        Loading…
      </div>
    </main>
  );
}
